export default __webpack_public_path__ + "images/U2.a7b204d.png";